import React, {useEffect, useState} from "react";
import { useSelector, useDispatch } from "react-redux";
import CreateSkillScheduleFormWrapper from "./CreateSkillScheduleFormWrapper";
import EditSkillScheduleFormWrapper from "./EditSkillScheduleFormWrapper";

import { getSkillSchedules, createSkillSchedule, updateSkillSchedule } from "../../../store/skillSchedules/skillSchedule-actions";
import { getAbortSignal } from "../../../util/signalHelper";

import { useNavigate } from "react-router-dom";
import { ValidationState } from "../../../validation/ValidationState";
import { validateSkillSchedule } from "../../../validation/SkillSchedulerValidation";

const SkillSchedulerForm = props => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {isCreate} = props;
    const {token} = useSelector(state => state.auth);
    const {skillSchedules, dataLoaded, dataValid} = useSelector(state => state.skillSchedules);
    const [validationState, setValidationState] = useState(new ValidationState())

    console.log(isCreate)
    console.log("isCreate")

    useEffect(() => {
        if (!token) return;
        const [skillScheduleSignal, skillScheduleController] = getAbortSignal();
        if (dataLoaded && dataValid) return;

        dispatch(getSkillSchedules(skillScheduleSignal, token));

        return () => {
            console.count("Schedules -> cancel fetchSchedules");
            try {
                skillScheduleController.abort();
            } catch (e) {

            }
        }
    }, [token, dataLoaded, dataValid, dispatch]);

    const handleCreate = (skillSchedule) => {
       const res = validate(skillSchedule);
       if (res.hasErrors) return;
        dispatch(createSkillSchedule(token, skillSchedule, navigate));
    }

    const handleUpdate = (skillSchedule) => {
        const res = validate(skillSchedule);
        if (res.hasErrors) return;
        dispatch(updateSkillSchedule(token, skillSchedule));
    }

    const handleReload = () => {
        
    }

    const handleCancel = () => {
        setValidationState(new ValidationState());
    }

    const validate = skillSchedule => {
        const validationState = validateSkillSchedule(skillSchedule);
        setValidationState(validationState);
        return validationState;
    }

    return (<>
        {isCreate && <CreateSkillScheduleFormWrapper 
            skillSchedules={skillSchedules}
            onSave={handleCreate}
            onCancel={handleCancel}
            onReload={handleReload}
            validationState={validationState}
        />}
        {!isCreate && <EditSkillScheduleFormWrapper 
            skillSchedules={skillSchedules}
            onSave={handleUpdate}
            onReload={handleReload}
            onCancel={handleCancel}
            validationState={validationState}
        />}
    </>)
}

export default SkillSchedulerForm;